import React from 'react'
import useSwr from 'swr'

import { endpoints } from '../../revelry_api/endpoints'
import { http } from '../../revelry_api/http'
import { FlowerProduct } from '../../types'

export interface IFlowerProductsContext {
  products: FlowerProduct[]
  productCodeProductMap: Record<string, FlowerProduct>
  isChildOfProvider: boolean
  loading: boolean
}

const FlowerProductsContext = React.createContext<IFlowerProductsContext>({
  products: [],
  productCodeProductMap: {},
  isChildOfProvider: false,
  loading: false,
})

interface Props extends React.PropsWithChildren {
  facilityID: number | null
}

export const FlowerProductsContextProvider: React.FC<Props> = ({ facilityID, children }) => {
  const { data, error } = useSwr<FlowerProduct[]>(
    endpoints.flowerstoreProducts(facilityID),
    http.get,
  )
  const [productCodeProductMap, setProductCodeProductMap] = React.useState<
    Record<string, FlowerProduct>
  >({})
  const numProducts = data?.length || 0

  React.useEffect(() => {
    if (numProducts > 0) {
      const map = {}
      data.map((flowerProduct) => (map[flowerProduct.code] = flowerProduct))
      setProductCodeProductMap(map)
    }
  }, [facilityID, numProducts])

  return (
    <FlowerProductsContext.Provider
      value={{
        products: data || [],
        productCodeProductMap,
        isChildOfProvider: true,
        loading: !data && !error,
      }}
    >
      {children}
    </FlowerProductsContext.Provider>
  )
}

export default FlowerProductsContext
